/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIsZero } from '../../factoriesAny.js';
export var isZeroDependencies = {
  typedDependencies: typedDependencies,
  createIsZero: createIsZero
};